import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import FavoriteIcon from '../Components/FavoriteIcon';

const MultiCarouselProduct = ({ item, index, onClick }) => {
   return <a href={!onClick || (item.isConfiguratorProduct || item.isSuperbuilderProduct) ? item.url : ""} title={item.name} itemScope="" itemType="http://schema.org/Product" key={item.name + index} className="product__wrapper">
        <FavoriteIcon articleNumber={item.id} />
        <figure className={`product__figure ${item.environmentImageUrl ? "has-environment" : ""}`}>
            {item.imageData != null && item.imageData.src ? (
                <Fragment>

                    {item.newssvg != "" && item.newssvg == "news" && item.labelImageNewsUrl 
                        ? <div className="campaign-image-list product-detail__news-text-list"
                            style={{
                                color: item.newsLabelColor,
                                backgroundColor: item.newsLabelBackgroundColor
                            }}>{translate("general.newslabeltext")}</div>
                        : null
                    }

                    {item.campaignSvg != "" && item.newssvg == "" 
                        ?   (<div className="campaign-image-list product-detail__campaign-text-list"
                            style={{
                                color: item.campaignPercentageColor,
                                backgroundColor: item.campaignPercentageBackgroundColor
                            }}>{translate("general.campaignlabeltext")}</div>
                            )
                        : null
                    }

                    <img itemProp="image" alt={item.imageData.alt} src={item.imageData.src} className="product__image"></img>
                    {item.environmentImageUrl && <img itemProp="image" src={item.environmentImageUrl} alt={item.environmentImageAlt} className="product__image--environment"></img>}
                </Fragment>
            ) : (<span className="product__image--missing">{translate('product.noproductimage')}</span>)}
            {/* <a href="/kvinna/blusar/kubrick-l-637249021158497661" itemProp="url" className="product__image-link"></a> */}
        </figure>
        <article className="product__info">
            <div className="product__name-container">
                <h4 itemProp="name" className="product__name small">{item.name}</h4>
                {item.isSuperbuilderProduct &&
                    <span className="product__config-indicator hover-info">
                        <span className="hover-info__box">{translate('product-item.superbuilder')}</span>
                        <svg className={item.isQuickSearchItem == true ? "small-config-btn" : ""} >
                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#superbuilder"></use>
                        </svg>
                    </span>
                }
                {item.isConfiguratorProduct && !item.isSuperbuilderProduct &&
                    <span className="product__config-indicator hover-info">
                        <span className="hover-info__box">{translate('product-item.configurator')}</span>
                        <svg className={item.isQuickSearchItem == true ? "small-config-btn" : ""} >
                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#adjust"></use>
                        </svg>
                    </span>
                }

            </div>
            <div itemProp="brand" className="product__brand">{item.brand}</div>
            {renderPrice(item, onClick)}
            {renderQuickSearchItemPrice(item)}
            {renderQuickSearchNonCampaignItemPrice(item)}
            {onClick && <button className="button button--wide" onClick={() => (item.isConfiguratorProduct || item.isSuperbuilderProduct) ? null : onClick(item.articleNumber)}>{(item.isConfiguratorProduct || item.isSuperbuilderProduct) ?
            translate("configurator.button.configure") : translate('common.addProduct')}</button>}
        </article>
    </a>
}
const renderPrice = (item, onClick) => {

    if (!item.isQuickSearchItem && item.price) {
        return item.isSuperbuilderProduct ?
            <span className='product__price product__price--small'>{item.superbuilderProductText}</span>

            : <div className={`product__price ${onClick ? "product__price--smallfont" : ""}`} itemProp="offers" itemScope="" itemType="http://schema.org/Offer">
                {item.campaignPrice && item.campaignPrice !== "" && item.campaignPrice !== "0" ?
                    <Fragment>
                        <span className="product__old-price">
                            <span>{item.pricePrefix}&nbsp;</span>
                            {item.price}
                        </span>

                        <span className="product__campaign-price">
                            <span>{item.pricePrefix}&nbsp;</span>
                            {item.campaignPrice}
                        </span>
                    </Fragment>
                    :
                    <Fragment>
                        <span className="price">
                            <span>{item.pricePrefix}&nbsp;</span>
                            {item.price}
                            {/* /{item.priceUnit} */}
                        </span>
                    </Fragment>
                }
            </div>
    }

}

const renderQuickSearchItemPrice = (item) => {

    if (item.isQuickSearchItem == true && item.campaignPrice && item.price) {
        return item.isSuperbuilderProduct ? <span className='product__price'>{item.SuperbuilderProductText}</span>
            : <div className="product__price" itemProp="offers" itemScope="" itemType="http://schema.org/Offer">
                <Fragment>
                    <span className="product__old-price">
                        <span>{item.pricePrefix}&nbsp;</span>
                        {item.price}
                    </span>

                    <span className="product__campaign-price">
                        <span>{item.pricePrefix}&nbsp;</span>
                        {item.campaignPrice}
                    </span>
                </Fragment>
            </div>
    }
}

const renderQuickSearchNonCampaignItemPrice = (item) => {

    if (item.isQuickSearchItem == true && !item.campaignPrice && item.price) {
        return item.isSuperbuilderProduct ? <span className='product__price'>{item.SuperbuilderProductText}</span>
            : <div className="product__price" itemProp="offers" itemScope="" itemType="http://schema.org/Offer">
                <Fragment>
                    <span className="price">
                        <span>{item.pricePrefix}&nbsp;</span>
                        {item.price}
                        {/* /{item.priceUnit} */}
                    </span>
                </Fragment>
                {/* <meta itemProp="price" content={item.price}></meta>
        <meta itemProp="priceCurrency" content="SEK"></meta>
        <link itemProp="availability" href="http://schema.org/InStock"></link>
        <link itemProp="url" href={item.url}></link> */}
            </div>
    }
}
export default MultiCarouselProduct;
